import {Component, Input, OnInit} from '@angular/core';
import {DeviceMeasurement} from "../../../../model/device-measurement";
import {Template} from "../../../../model/template";
import {AssetMeasurement} from "../../../../model/asset-measurement";

@Component({
  selector: 'app-template-sensors',
  templateUrl: './template-sensors.component.html',
  styleUrls: ['./template-sensors.component.scss']
})
export class TemplateSensorsComponent implements OnInit {

  @Input()
  public template: Template;

  public measurements: (DeviceMeasurement | AssetMeasurement)[];
  public totalMeasurements: number;
  public loadingMeasurements: boolean;

  public rows = 10;
  public first = 0;

  constructor() {
    this.measurements = [];
  }

  ngOnInit(): void {
    this.loadMeasurements();
  }

  private loadMeasurements() {
    this.loadingMeasurements = true;
    if (this.template) {
      if (this.template.type === 'DEVICE') {
        this.measurements = this.template.content?.deviceMeasurements ? this.template.content.deviceMeasurements : [];
      } else {
        this.measurements = this.template.content?.assetMeasurements ? this.template.content.assetMeasurements : [];
      }
    }
    this.totalMeasurements = this.measurements.length;
    this.loadingMeasurements = false;
  }

}
